namespace $ { $mol_style_attach( "mol/plot/ruler/vert/vert.view.css",
 "[mol_plot_ruler_vert_label] {\n\ttransform: translateY( 4px );\n}\n"
) }